import CheckBox from '@components/FormFields/CheckBox';
import s from '../UserWorkflowDetailCustomerView.module.scss';

type ValidProp = 'canAssign' | 'canInviteCollaborators' | 'canReceiveCustomerNotifications';

type Props = {
  propName: ValidProp;
  collaborator: {
    id: string;
    canHavePermissionsChanged: boolean;
  } & Record<ValidProp, boolean>;
  isAllowedToChange: boolean;
  onChange: (key: ValidProp) => void;
  label: string;
};

const PermissionCheckBox: React.FC<Props> = ({
  propName,
  collaborator,
  isAllowedToChange,
  onChange,
  label,
}) => {
  const disabled = !isAllowedToChange || !collaborator.canHavePermissionsChanged;
  const fieldId = `${collaborator.id}:${propName}`;
  const value = collaborator[propName];

  if (disabled && !value) {
    return null;
  }

  return (
    <CheckBox
      disabled={disabled}
      id={fieldId}
      name={fieldId}
      values={{ [fieldId]: value }}
      hasFixedHeight={false}
      onChange={() => onChange(propName)}
      label={label}
      noFlex
      className={s['permission-check-box']}
    />
  );
};

export default PermissionCheckBox;